<template>
  <div class="green lighten-4">
    <v-container style="max-width: 1800px">
      <v-btn
        class="white mr-2"
        link
        :to="`/project/${$route.params.projectId}/reports/accounting/invoice`"
        active-class="white--text primary"
        outlined
        elevation="0"
        >{{ $t('invoice.title') }}</v-btn
      >
      <v-btn
        class="white mr-2"
        link
        :to="`/project/${$route.params.projectId}/reports/accounting/receipt`"
        active-class="white--text primary"
        outlined
        elevation="0"
        >{{ $t('receipt.title') }}</v-btn
      >
      <v-btn
        class="white mr-2"
        link
        :to="`/project/${$route.params.projectId}/reports/accounting/creditnote`"
        active-class="white--text primary"
        outlined
        elevation="0"
        >{{ $t('credit_note.title') }}</v-btn
      >
      <v-btn
        class="white mr-2"
        link
        :to="`/project/${$route.params.projectId}/reports/accounting/billpaymentreport`"
        active-class="white--text primary"
        outlined
        elevation="0"
        >Bill Payment</v-btn
      >
      <v-btn
        class="white mr-2"
        link
        :to="`/project/${$route.params.projectId}/reports/accounting/qrpaymentreport`"
        active-class="white--text primary"
        outlined
        elevation="0"
        >QR Payment</v-btn
      >
    </v-container>
  </div>
</template>

<script>
export default {
  props: {
    type: String
  }
};
</script>

<style lang="scss" scoped>
.tool-bar{
  background-color: rgb(233,249,238);
  border: 1px solid rgb(221,242,228);
}
</style>
